function isDesktopViewport() {
  return window.matchMedia('(min-width: 990px)').matches;
}

// Copre sia il 2° livello (<header-menu><details>...) sia il 3° livello
// (<details> annidato dentro il sottomenu, senza wrapper <header-menu>):
// ogni <details> dentro il menu diventa hover-attivabile in modo
// indipendente, quindi funziona a qualunque livello di annidamento.
document.querySelectorAll('.header__inline-menu details').forEach((details) => {
  let closeTimeout;

  details.addEventListener('mouseenter', () => {
    if (!isDesktopViewport()) return;
    clearTimeout(closeTimeout);
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
  });

  details.addEventListener('mouseleave', () => {
    if (!isDesktopViewport()) return;
    closeTimeout = setTimeout(() => {
      details.removeAttribute('open');
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    }, 150);
  });
});
